export default "/assets/images/mila-opened-door-filter-boxes.cb1c82ddc3a7fe91.png";